import { render, staticRenderFns } from "./Categorias.vue?vue&type=template&id=59e20b99"
import script from "./Categorias.vue?vue&type=script&lang=js"
export * from "./Categorias.vue?vue&type=script&lang=js"
import style0 from "./Categorias.vue?vue&type=style&index=0&id=59e20b99&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports